import React from "react";
import styles from "./spinner.module.css";
import { LoaderCircle } from "lucide-react";

const Spinner = ({ width = 24, height = 24, className }) => {
  return (
    <div
      className={`${styles.wrapper} ${styles[className]}`}
      data-testid="spinner"
    >
      <LoaderCircle className={styles.spinner} width={width} height={height} />
    </div>
  );
};

export default Spinner;
